module.exports = __webpack_public_path__ + "static/media/apartment2.a1a04f4e.jpg";